import React from 'react';
import { BookmarkIcon, HeartIcon } from 'lucide-react';
import { cn } from '../../utils/cn';

/**
 * One save control, two presentations.
 *
 * Both Discover compositions write to the same saved state — the heart on a
 * photograph and the bookmark in a row of actions are the same act, never two
 * separate mechanisms.
 */
interface SaveButtonProps {
  saved: boolean;
  onToggle: () => void;
  /** What is being saved, for the accessible name. */
  subject: string;
  shape?: 'heart' | 'bookmark';
  /** Floats over photography rather than sitting in a row of controls. */
  overlay?: boolean;
  withLabel?: boolean;
  className?: string;
}
export function SaveButton({
  saved,
  onToggle,
  subject,
  shape = 'bookmark',
  overlay = false,
  withLabel = false,
  className
}: SaveButtonProps) {
  const Icon = shape === 'heart' ? HeartIcon : BookmarkIcon;
  return <button type="button" onClick={onToggle} aria-pressed={saved} aria-label={saved ? `Remove ${subject} from saved` : `Save ${subject}`} className={cn('inline-flex min-h-touch items-center justify-center gap-2 rounded-lg border text-body-sm font-medium transition-[color,background-color,border-color,transform] duration-150 ease-out active:scale-[0.97]', withLabel ? 'min-w-touch px-3.5' : 'min-w-touch', overlay ? 'border-white/50 bg-white/90 backdrop-blur hover:bg-white' : 'border-line bg-surface hover:border-line-strong', saved ? 'text-brand-700' : 'text-ink-muted hover:text-ink', className)} data-id="element-1529" data-mp="2wcp3cpcadeyf">
      <Icon aria-hidden className={cn('h-5 w-5', saved && 'fill-brand-700')} strokeWidth={saved ? 2 : 1.8} data-id="element-1530" data-mp="2lrch93alzvv7" />
      {withLabel && <span data-id="element-1531" data-mp="2grgh5f518okx">{saved ? 'Saved' : 'Save'}</span>}
    </button>;
}